<template>
  <v-layout wrap px-sm-16 px-md-0 px-lg-16>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-flex xs12 text-center class="head" pt-5 pb-6> Hivekeep Blog </v-flex>
    <v-flex xs12>
      <v-layout wrap>
        <v-flex md6 px-sm-2 px-md-0 lg6 pl-md-0 pl-lg-14 pb-2 align-self-center>
          <v-card tile height="500px">
            <v-img height="500px" class="align-center">
              <!-- src="../../assets/images/waterdrop.jpg" -->
              <v-layout v-if="newobj" wrap pa-12>
                <v-flex xs6 sm6 md6 lg4 pb-3 pb-lg-7 class="clr"
                  >LATEST UPDATE
                </v-flex>
                <v-flex
                  text-left
                  xs6
                  sm6
                  md6
                  lg3
                  pb-lg-7
                  class="regulartext clr"
                  ><timeago :datetime="newobj.update_date"></timeago>
                </v-flex>
                <v-flex xs12 lg8 style="color: black" class="subhead"
                  >{{ newobj.heading }}
                </v-flex>
                <v-flex xs12 py-4 class="regulartext clr"
                  >{{ newobj.author }}
                </v-flex>
                <v-flex xs12> </v-flex>
                <v-flex xs12 md12>
                  <router-link
                    style="text-decoration: none; color: black"
                    :to="'/blogView?blog=' + newobj._id"
                  >
                    <v-btn
                      rounded
                      color="#FEBD08"
                      style="text-transform: none; font-family: sofiapromedium"
                      >Read More
                    </v-btn>
                  </router-link>
                </v-flex>
                <v-flex xs6 sm3 md4 lg3 pt-3 pt-lg-8>
                  <v-layout wrap>
                    <v-flex xs5 md6 lg5 text-left>
                      <v-icon
                        :disabled="firstItem ? true : false"
                        @click="show()"
                        large
                        color="#D0D0D5"
                        >mdi-arrow-left-circle-outline</v-icon
                      >
                    </v-flex>
                    <v-flex xs5 md6 lg5 pr-lg-3 text-right
                      ><v-icon
                        @click="showImage()"
                        :disabled="lastItem ? true : false"
                        large
                        color="#D0D0D5"
                        >mdi-arrow-right-circle-outline</v-icon
                      >
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs6 sm9 md8 pt-4 lg8 pt-lg-10 text-right>
                  <v-dialog
                    :retain-focus="false"
                    v-model="dialog"
                    persistent
                    max-width="600px"
                    :key="dialog"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" large color="#D0D0D5"
                        >mdi-share-variant</v-icon
                      >
                    </template>
                    <v-card>
                      <v-card-title>
                        <span
                          style="
                            text-transform: none;
                            font-family: sofiapromedium;
                          "
                          >Share this Page</span
                        >
                        <v-spacer></v-spacer
                        ><v-icon @click="dialog = false">mdi-close</v-icon>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <span
                            class="px-2"
                            v-for="(item, i) in socialMedias"
                            :key="i"
                          >
                            <ShareNetwork
                              style="text-decoration: none"
                              :network="item.network"
                              :url="'http://indianbees.org' + $route.fullPath"
                              :title="
                                item.network == 'messenger' ||
                                item.network == 'linkedin'
                                  ? ''
                                  : newobj.author + ','
                              "
                            >
                              <v-icon
                                style="text-decoration: none"
                                color="#9D9C9C"
                                size="30"
                                >{{ item.icon }}</v-icon
                              >
                            </ShareNetwork>
                          </span>
                        </v-container>
                      </v-card-text></v-card
                    >
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 md6 lg6 pr-lg-14 pb-2 class="hidden-sm-and-down">
          <v-card v-if="newobj" tile height="500px">
            <v-img height="500px" :src="mediaURL + newobj.photo">
              <template v-slot:placeholder> <ImageLoader /> </template>
            </v-img>
          </v-card>
        </v-flex>
        <v-flex xs12 px-md-12>
          <v-layout wrap pb-lg-12 pb-6>
            <!-- v-if="blog.length>0" -->
            <!-- <OwlCarousel :nav="true" :dots="false" :responsive="owlResponsive"> -->
            <template v-for="(item, i) in blog">
              <v-flex
                v-if="item._id != newobj._id"
                py-2
                align-self-center
                text-center
                px-2
                px-lg-2
                xs12
                md4
                :key="i"
              >
                <v-card tile>
                  <v-layout wrap style="font-family: robotoregular">
                    <v-flex xs12>
                      <v-img :src="mediaURL + item.photo">
                        <template v-slot:placeholder>
                          <ImageLoader />
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex
                      px-3
                      px-md-5
                      pt-4
                      pt-md-5
                      xs6
                      text-left
                      style="
                        color: #ababab;
                        font-size: 12px;
                        font-family: sofiapro;
                      "
                    >
                      {{ item.create_date.slice(0, 10) }}
                    </v-flex>
                    <v-flex
                      px-3
                      px-md-5
                      xs12
                      md10
                      text-left
                      style="font: 18px robotobold"
                      pt-2
                    >
                      <router-link
                        style="text-decoration: none; color: black"
                        :to="'/blogView?blog=' + item._id"
                      >
                        <span class="texttt"> {{ item.heading }} </span>
                      </router-link>
                    </v-flex>
                    <v-flex
                      py-3
                      class="clr regulartext"
                      px-3
                      px-md-5
                      xs12
                      text-left
                    >
                      {{ item.author }}
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </template>
            <!-- </OwlCarousel> -->
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 3, nav: false },
      },
      socialMedias: [
        { network: "whatsapp", icon: "mdi-whatsapp" },
        // { network: "Messenger", icon: "mdi-facebook-messenger" },
        { network: "facebook", icon: "mdi-facebook" },
        { network: "twitter", icon: "mdi-twitter" },
        { network: "email", icon: "mdi-email" },
        { network: "linkedin", icon: "mdi-linkedin" },
        { network: "telegram", icon: "mdi-telegram" },
      ],
      blog: [],
      dialog: false,
      curImage: null,
      newobj: {},
      appLoading: false,
      lastItem: false,
      firstItem: false,
      blogLength: null,
      ServerError: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    show() {
      var newobj = {};
      if (this.newobj._id == this.blog[1]._id) {
        this.firstItem = true;
      }
      for (var i = 0; i < this.blog.length; i++) {
        if (this.newobj._id == this.blog[i]._id) {
          if (i > 0) {
            newobj = this.blog[i - 1];
            this.lastItem = false;
          }
        }
      }
      this.newobj = newobj;
    },
    showImage() {
      var newobj = {};
      if (this.newobj._id == this.blog[this.blogLength - 2]._id) {
        this.lastItem = true;
      }
      for (var i = 0; i < this.blog.length - 1; i++) {
        if (this.newobj._id == this.blog[i]._id) {
          this.firstItem = false;
          newobj = this.blog[i + 1];
        }
      }

      this.newobj = newobj;
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/blog/list",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.blog = response.data.data;
            this.blogLength = response.data.data.length;
            this.newobj = this.blog[0];
            if (this.newobj) this.firstItem = true;
            this.pages = response.data.pages;
            this.appLoading = false;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.texttt {
  line-height: 1.5em;
  min-height: 4.5em;
  float: left;
}
</style>